
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DeviceInfo, SharedDeviceInfo } from '@/types/device-info';

@Component({
    components: {},
})
export default class DeviceSettingsShareMenu extends Vue {
    @Prop({ required: true })
    share!: SharedDeviceInfo;

    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: true })
    onResend!: (share: SharedDeviceInfo) => void;

    @Prop({ required: false })
    onEdit!: (share: SharedDeviceInfo) => void;

    @Prop({ required: true })
    onRemove!: (share: SharedDeviceInfo) => void;
}
